export default __webpack_public_path__ + "static/media/work4image1.be6a266b.jpg";